import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const receiptsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/receipts",
  component: lazyRouteComponent(() => import("./receipts.page.js"), "ReceiptsPage"),
});
